import { useCallback, useState } from 'react';

import { PHOTO_ATTACHMENT_QUERY } from 'src/graphql/mobile/query';
import client from 'src/utils/api/client';
import logger from 'src/utils/logger';

export default (jobId) => {
  const [photoRecordsData, setPhotoRecordsData] = useState([]);

  return {
    execute: useCallback(async () => {
      try {
        const { data } = await client.query({
          query: PHOTO_ATTACHMENT_QUERY,
          variables: {jobId},
          fetchPolicy: 'network-only'
        });
        setPhotoRecordsData(data.JobPhotoRecords);
        return data.JobPhotoRecords;
      } catch (err) {
        logger.error(err);
        return [];
      }
    }, [jobId]),
    photoRecordsData
  };
}
